import React from 'react';
import { useTranslation } from 'react-i18next';
import { CircleHelp } from 'lucide-react';

/**
 * Last step, media area: only the BOTTOM of the user's own rail — the last
 * three page tools fading out upwards, the chat/calendar group, and the
 * pulsing Help button — beside a short note. Fixed size; it never scrolls.
 */
export default function DoneFinale({ visibleTools }) {
  const { t } = useTranslation();
  const tail = visibleTools.filter((tool) => !tool.footer).slice(-3);
  const footer = visibleTools.filter((tool) => tool.footer);
  const marker = '\u0000';
  const [before, after] = t('onboarding.done.copy', { replay: marker }).split(marker);

  return (
    <div className="ob-finale">
      <div className="ob-rail-crop" aria-hidden="true">
        {tail.map((tool) => (
          <span key={tool.id} className="ob-rail-crop-it">
            <tool.Icon size={15} />
          </span>
        ))}
        <span className="ob-rail-crop-sep" />
        {footer.map((tool) => (
          <span key={tool.id} className="ob-rail-crop-it">
            <tool.Icon size={15} />
          </span>
        ))}
        <span className="ob-rail-crop-help">
          <CircleHelp size={18} />
        </span>
      </div>
      <div className="ob-finale-copy">
        <span className="ob-chip">
          <CircleHelp size={13} aria-hidden="true" />
          {t('help.title')}
        </span>
        <p>
          {before}
          <b>{t('help.replay')}</b>
          {after}
        </p>
      </div>
    </div>
  );
}
